import { Editor } from "tinymce";
import { decodeMML } from "./Utils";

function check(element:Element):boolean{
    const role = element.getAttribute('role');
    return role === 'math'
}

export function addContextMenus(editor:Editor){

    editor.ui.registry.addMenuItem('get-formula', {
        icon: "copy",
        text: "Formel kopieren",
        onAction: () => {
            const node = editor.selection.getNode();
            let mml = node.getAttribute('data-mathml')
            mml = decodeMML(mml)
            navigator.clipboard.writeText(mml)
        }
    })

    editor.ui.registry.addContextMenu('math', {
        update: (element) => {
            console.log(element)
            return !check(element) ? '' : 'get-formula';
        }
    });

}

